import { mapState } from "vuex";

const AuthState = {
  install(Vue) {
    Vue.mixin({
      computed: {
        ...mapState({
          $authenticated: state => state.auth.authenticated,
          $check_token_busy: state => state.auth.check_token_busy,
        }),
        $checkingAuthState () {
          return !this.$authenticated && this.$check_token_busy;
        },
      },
    });
  },
};

export default AuthState;
